<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs [(ttSelectedId)]="selectedBgJobScheduleMain">
                <tt-tab ttId="BASIS" ttLabel="gb_jobschedule_main_basis"></tt-tab>
                <tt-tab ttId="PROC" ttLabel="gb_jobschedule_main_proc"></tt-tab>
                <tt-tab ttId="STAT" ttLabel="gb_jobschedule_main_stat"></tt-tab>
            </tt-tabs>

            <div [hidden]="selectedBgJobScheduleMain !== 'BASIS'">
                <ng-container *ngTemplateOutlet="basics"></ng-container>
            </div>

            <div [hidden]="selectedBgJobScheduleMain !== 'PROC'">
                <ng-container *ngTemplateOutlet="procedure"></ng-container>
            </div>

            <div [hidden]="selectedBgJobScheduleMain !== 'STAT'">
                <ng-container *ngTemplateOutlet="statistics"></ng-container>
            </div>

            <tt-button-save ttText="jobschedule_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
            <tt-button ttText="jobschedule_add_to_queue" (ttClick)="addToQueueChanges()" [ttSpin]="addingToQueue" ttIcon="fas fa-sync"></tt-button>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="jobschedule_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5" ttHeading="gb_jobschedule_main_basis">
                        <ng-container *ngTemplateOutlet="basics"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5" ttHeading="gb_jobschedule_main_proc">
                        <ng-container *ngTemplateOutlet="procedure"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40">
                    <tt-card class="col-xs-12 p-5" ttHeading="gb_jobschedule_main_stat">
                        <ng-container *ngTemplateOutlet="statistics"></ng-container>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-button-save ttText="jobschedule_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
            </tt-card>

            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-button ttText="jobschedule_add_to_queue" (ttClick)="addToQueueChanges()" [ttSpin]="addingToQueue" ttIcon="fas fa-sync"></tt-button>
            </tt-card>
        </div>
    </div>
</tt-page>

<ng-template #basics>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="jobschedule_keyno" [ttModel]="edit.jobschedule_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="jobschedule_name" [(ttModel)]="edit.jobschedule_name" ttRequired></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-checkbox ttLabel="run_parallell" [(ttModel)]="edit.run_parallell"></tt-checkbox>
        <tt-checkbox ttLabel="delete_job_after_execute" [(ttModel)]="edit.delete_job_after_execute"></tt-checkbox>
        <tt-select ttLabel="repeat_every_type" [(ttModel)]="edit.repeat_every_type" (ttModelChange)="onChanged($event, 'repeat_every_type')" [ttData]="selectListRepeatEveryTypes" ttDataId="repeat_every_type_id" ttDataName="repeat_every_type_name"></tt-select>
        <tt-select ttLabel="repeat_every_number" [(ttModel)]="edit.repeat_every_number" [ttData]="selectListRepeatEveryNumbers" ttDataId="repeat_every_number_id" ttDataName="repeat_every_number_name"></tt-select>

        <div [hidden]="edit.repeat_every_type === 'year' || edit.repeat_every_type === 'month' || edit.repeat_every_type === 'day'">
            <tt-checkbox ttLabel="repeat_monday" [(ttModel)]="edit.repeat_monday"></tt-checkbox>
            <tt-checkbox ttLabel="repeat_tuesday" [(ttModel)]="edit.repeat_tuesday"></tt-checkbox>
            <tt-checkbox ttLabel="repeat_wednesday" [(ttModel)]="edit.repeat_wednesday"></tt-checkbox>
            <tt-checkbox ttLabel="repeat_thursday" [(ttModel)]="edit.repeat_thursday"></tt-checkbox>
            <tt-checkbox ttLabel="repeat_friday" [(ttModel)]="edit.repeat_friday"></tt-checkbox>
            <tt-checkbox ttLabel="repeat_saturday" [(ttModel)]="edit.repeat_saturday"></tt-checkbox>
            <tt-checkbox ttLabel="repeat_sunday" [(ttModel)]="edit.repeat_sunday"></tt-checkbox>
        </div>

        <div [hidden]="edit.repeat_every_type === 'hour' || edit.repeat_every_type === 'minute' || edit.repeat_every_type === 'second'">
            <tt-time ttLabel="execute_from_time" [(ttModel)]="edit.execute_from_time"></tt-time>
            <tt-time ttLabel="execute_to_time" [(ttModel)]="edit.execute_to_time"></tt-time>
        </div>

        <div [hidden]="edit.repeat_every_type === 'year' || edit.repeat_every_type === 'month' || edit.repeat_every_type === 'week' || edit.repeat_every_type === 'day'">
            <tt-time ttLabel="execute_at_time" [(ttModel)]="edit.execute_at_time"></tt-time>
        </div>

        <div [hidden]="edit.repeat_every_type === 'year' || edit.repeat_every_type === 'month'">
            <tt-input-number ttLabel="execute_at_dayinmonth" [(ttModel)]="edit.execute_at_dayinmonth" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        </div>

        <div [hidden]="edit.repeat_every_type === 'year'">
            <tt-input-number ttLabel="execute_at_month" [(ttModel)]="edit.execute_at_month" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        </div>
    </ng-container>
</ng-template>

<ng-template #procedure>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="p2_datatask_keyno" [(ttModel)]="edit.p2_datatask_keyno"></tt-input>
        <tt-input ttLabel="proc_name" [ttModel]="edit.proc_name" ttReadonly></tt-input>
        <tt-textarea ttLabel="processing_parms" [(ttModel)]="edit.processing_parms"></tt-textarea>
        <tt-checkbox ttLabel="continue_if_error" [(ttModel)]="edit.continue_if_error"></tt-checkbox>
    </ng-container>
</ng-template>

<ng-template #statistics>
    <ng-container *ngIf="!!edit">
        <tt-input-number ttLabel="processing_count" [ttModel]="edit.processing_count" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
        <tt-input ttLabel="last_add_to_jobqueue_dt" [ttModel]="edit.last_add_to_jobqueue_dt" ttReadonly></tt-input>
        <tt-input ttLabel="last_processing_start_dt" [ttModel]="edit.last_processing_start_dt" ttReadonly></tt-input>
        <tt-input ttLabel="last_processing_end_dt" [ttModel]="edit.last_processing_end_dt" ttReadonly></tt-input>
        <tt-input ttLabel="next_run_datetime" [ttModel]="edit.next_run_datetime" ttReadonly></tt-input>
        <tt-input-number ttLabel="last_processing_code" [ttModel]="edit.last_processing_code" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
        <tt-textarea ttLabel="last_processing_message" [ttModel]="edit.last_processing_message" ttReadonly></tt-textarea>
        <tt-datetime ttLabel="reg_datetime" [ttModel]="edit.reg_datetime" ttReadonly></tt-datetime>
        <tt-input ttLabel="reg_by_portal_user_keyno" [ttModel]="edit.reg_by_portal_user_keyno" ttReadonly></tt-input>
        <tt-datetime ttLabel="mod_datetime" [ttModel]="edit.mod_datetime" ttReadonly></tt-datetime>
        <tt-input ttLabel="mod_by_portal_user_keyno" [ttModel]="edit.mod_by_portal_user_keyno" ttReadonly></tt-input>
    </ng-container>
</ng-template>
